import { endOfISOWeek, startOfISOWeek } from "date-fns";
import { ICashRegister, ValidationSchema } from "lib";

export type DSFinVKExportForm = {
    from: Date;
    to: Date;
    clientId: ICashRegister["id"] | null;
};

// Initial values for the DSFinV-K Report export form is from start of current week to end of current week.
export const defaultDSFinVKExportForm: DSFinVKExportForm = {
    from: startOfISOWeek(new Date()),
    to: endOfISOWeek(new Date()),
    clientId: null,
};

export const schemaDSFinVKExportForm: ValidationSchema<DSFinVKExportForm> = {
    from: { required: true },
    to: { required: true },
};
